import Component from '../../common/Component';
import app from '../app';
export default class NotificationType extends Component {
  view() {
    const notification = this.attrs.notification;
    const NotificationComponent = app.notificationComponents[notification.contentType()];
    return !!NotificationComponent ? m(NotificationComponent, {
      notification: notification
    }) : null;
  }
}
flarum.reg.add('core', 'forum/components/NotificationType', NotificationType);